/**
 * One Maps JS script for the whole dashboard.
 *
 * @react-google-maps/api only loads libraries on the FIRST useJsApiLoader call
 * for a given script id. Mixing ids (or loading once without `places`) silently
 * kills Autocomplete on later pages — Fuel station search was a casualty.
 *
 * Prefer Places API (New) (`AutocompleteSuggestion`). Legacy `Autocomplete`
 * widgets hit AutocompletionService.GetPredictions and fail with
 * LegacyApiNotActivatedMapError when only Places API (New) is enabled.
 */

export const GOOGLE_MAPS_SCRIPT_ID = "trasse-maps-script";

/** Stable module-level reference — a new array each render re-loads the script. */
export const GOOGLE_MAPS_LIBRARIES: "places"[] = ["places"];

/** Weekly channel carries AutocompleteSuggestion / Place (New). */
export const GOOGLE_MAPS_VERSION = "weekly";

export function placesNamespaceReady(): boolean {
  return placesNewReady() || placesLegacyReady();
}

export function placesLegacyReady(): boolean {
  if (typeof window === "undefined") return false;
  const g = (
    window as unknown as {
      google?: { maps?: { places?: { Autocomplete?: unknown } } };
    }
  ).google;
  return typeof g?.maps?.places?.Autocomplete === "function";
}

export function placesNewReady(): boolean {
  if (typeof window === "undefined") return false;
  const g = (
    window as unknown as {
      google?: {
        maps?: {
          places?: {
            AutocompleteSuggestion?: { fetchAutocompleteSuggestions?: unknown };
            AutocompleteSessionToken?: unknown;
          };
        };
      };
    }
  ).google;
  return typeof g?.maps?.places?.AutocompleteSuggestion?.fetchAutocompleteSuggestions === "function";
}
